module.exports = __webpack_public_path__ + "04b8fe44c678327dc4cbfd2e7e1cc77f.png";